<template>
  <div>
    <h3 >Vivo批量搭建数据上传点</h3>



  <el-upload
    class="upload-demo"
    action="https://test.nbweiou.cn/api/Batchupload"
    :on-success="handleSuccess"
    :before-upload="beforeUpload">
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
  </el-upload>

    <h3 >cid数据上传点</h3>



    <el-upload
      class="upload-demo"
      action="https://test.nbweiou.cn/api/cidspk"
      :on-success="handleSuccess"
      :before-upload="beforeUpload">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: "batchUpdateCode",
  methods: {
    beforeUpload(file) {
      const isXls = file.type === 'application/vnd.ms-excel'
      const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isXls && !isXlsx) {
        this.$message.error('上传文件只能是xls/xlsx格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!')
      }
      return (isXls || isXlsx) && isLt2M
    },
    handleSuccess(response, file) {
      this.$message.success('上传成功')
      this.uploadFileUrl = response.data.url
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/batchUpdateCode.vue